import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserProductGroupCharges {
  constructor($scope, UserProductService, UserService) {
    $scope.parseInt = function(value) {
      return parseInt(value);
    };

    $scope.set_user_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.charge.buyer_id = ui.item.id;
          $scope.buyer_user_company = ui.item.value;
          $(this).val('');
          $scope.$apply();
          $scope.load_buyer_product_groups(ui.item.id);
        }
      });
    };

    $scope.load_buyer_product_groups = function(buyer_id) {
      $scope.product_groups = [];
      UserService.get_user_product_groups(buyer_id).then(function(data) {
        var existing_product_groups = _.pluck($scope.buyer_charges[buyer_id], 'product_group_id');
        _.each(data.product_groups, function(product_group) {
          if (($scope.charge.id && $scope.charge.product_group_id === product_group.id) || !_.contains(existing_product_groups, product_group.id))
            $scope.product_groups.push(product_group);
        });
      });
    };

    $scope.remove_user = function() {
      $scope.charge.buyer_id = null;
      $scope.buyer_user_company = null;
      $('input.user_company').val('');
      $scope.product_groups = [];
      $scope.charge.product_group_id = null;
    };

    $scope.load_charges = function() {
      $scope.loading = true;
      UserProductService.get_user_product_group_charges(window.user_id).then(function(data) {
        $scope.charges = data.charges;
        $scope.buyer_charges = _.groupBy(data.charges, 'buyer_id');
        $scope.buyers = data.buyers;
        $scope.loading = false;
      });
    };

    $scope.save_charge = function() {
      if (!$scope.charge.buyer_id || !$scope.charge.product_group_id) {
        alert('Please select a buyer and a product group!');
      } else {
        $scope.saving_charge = true;
        UserProductService.save_user_product_group_charge($scope.charge).then(function(data) {
          if (data.success) {
            $scope.saving_charge = false;
            $.fancybox.close();
            $scope.load_charges();
          }
        });
      }
    };

    $scope.add_charge = function() {
      $scope.charge = angular.copy(window.charge);
      $scope.charge.user_id = null;
      $scope.buyer_user_company = null;
      $scope.product_groups = [];
      $('input.user_company').val('');
      window.openFancyboxDialog('div#charge_dialog');
    };

    $scope.mass_add_charges = function() {
      $scope.charge = angular.copy(window.charge);
      $scope.charge.user_id = null;
      $scope.buyer_user_company = null;
      $scope.product_groups = [];
      $('input.user_company').val('');
      window.openFancyboxDialog('div#mass_charge_dialog');
    };

    $scope.mass_save_charges = function() {
      $scope.charge.product_groups = _.pluck(_.where($scope.product_groups, {
        checked: true
      }), 'id');
      if (!$scope.charge.buyer_id || $scope.charge.product_groups.length === 0) {
        alert('Please select a buyer and at least one product group!');
      } else {
        $scope.saving_charges = true;
        UserProductService.mass_save_user_product_group_charge($scope.charge).then(function(data) {
          if (data.success) {
            $scope.saving_charges = false;
            $.fancybox.close();
            $scope.load_charges();
          }
        });
      }
    };

    $scope.mass_renew_charges = function() {
      var selected_charges = [];
      _.each($scope.buyer_charges, function(charges) {
        if (charges[0].checked) {
          _.each(charges, function(charge) {
            selected_charges.push(charge.id);
          });
        }
      });

      if (selected_charges.length === 0) {
        alert('Please select at least one buyer!');
      } else {
        $scope.processing = true;
        UserProductService.mass_renew_user_product_group_charges(selected_charges).success(function(data) {
          if (data.success) {
            $scope.processing = false;
            $scope.load_charges();
          }
        });
      }
    };

    $scope.edit_charge = function(charge) {
      $scope.charge = angular.copy(charge);
      $scope.buyer_user_company = $scope.charge.buyer_user_company;
      $.fancybox($('div#charge_dialog'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        scrolling: 'no',
        afterShow: function() {
          $scope.load_buyer_product_groups($scope.charge.buyer_id);
          $scope.$apply();
        }
      });
    };

    $scope.delete_charge = function(charge_id) {
      if (confirm('Are you sure you want to delete this charge?')) {
        UserProductService.delete_user_product_group_charge(charge_id).then(function(data) {
          if (data.success)
            $scope.load_charges();
        });
      }
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.set_charges_checked = function() {
      _.each($scope.buyer_charges, function(charges) {
        charges[0].checked = $scope.checked_all_charges;
      });
    };

    $scope.init = function() {
      $scope.load_charges();
      $scope.set_user_autocomplete($('input.user_company'));
      $scope.user_type = window.user_type;
      $scope._ = _;
    };

    $scope.init();
  }
}

UserProductGroupCharges.$inject = ['$scope', 'UserProductService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-group-charges.ctrl.js